import { useQuery } from 'react-query';
import { APPOINTMENT_REMINDER_CONFIGURATION } from '../../constants/reactQuery.keys';
import { Appointment } from '../../services/Appointment';

export const useAppointmentReminderConfiguration = (practitionerId: number, enabled: boolean) => useQuery(
  [APPOINTMENT_REMINDER_CONFIGURATION, practitionerId],
  () => Appointment.fetchAppointmentReminderConfiguration(practitionerId),
  { enabled }
);
